var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHalfStar = function SvgHalfStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8 0 .64 1.973v9.547L8 11.056l-4.702 3.416 1.796-5.528L.392 5.528h5.812z"
  })));
};
export default SvgHalfStar;